export const Spanish = {
	'Login with': 'Login con',
	'Unique login': 'Login único',
	//Sections
	Articles: 'Artículos',
	Dictionary: 'Diccionario',
	Thesaurus: 'Thesaurus',
	News: 'Noticias',
	Media: 'Multimedia',
	Books: 'Libros',
	Book: 'Libro',
	Patent: 'Patente',
	Article: 'Artículo',
	EBooks: 'EBooks',
	'GALE Resources': 'Recursos GALE',
	'Aquino AI': 'Aquino IA',
	'Job Hunter': 'Empleo',
	'Interesting Links': 'Enlaces de interés',
	'Career Development': 'Desarrollo profesional',
	Tutorials: 'Tutoriales',
	'My favorities': 'Mis favoritos',
	Help: 'Ayuda',

	//Sections
	'16k+ library results': 'Más de 16 mil resultados en la biblioteca',

	'More than 20k words from the dictionary':
		'Más de 20 mil palabras del diccionario',

	'Thesaurus dictionary': 'Diccionario de sinónimos y antónimos',
	Patents: 'Patentes',
	'More than 20k Patent results': 'Más de 20 mil resultados de patentes',
	'Recent and relevant global news':
		'Noticias globales recientes y relevantes.',
	'Rich instructional videos': 'Videos instructivos de alta calidad',
	'16k+ books results': 'Más de 16 mil resultados de libros',

	'Learn about Soft Skills and American life':
		'Aprende sobre habilidades blandas y la vida en Estados Unidos',
	'Find your favorite content': 'Encuentra tu contenido favorito',
	Art: 'Arte',
	'More than 10k art stories': 'Más de 10 mil resultados de arte',
	'Library Video': 'Videos',
	'More than 2k job offers': 'Más de 2mil ofertas de empleo',

	// Home
	'The easiest way to Find': 'La forma más fácil de encontrar',
	knowledge: 'conocimiento',
	'Search for books, journals, and academic articles':
		'Busca libros, revistas y artículos académicos en cientos de bases de datos bibliográficas de todo el mundo. Gracias a nuestra inteligencia artificial integrada, podrás realizar búsquedas avanzadas más rápidas, precisas y adaptadas a tus necesidades específicas.',
	'Explore our Library': 'Explora nuestra Librería',
	'More than': 'Más de',
	'sources in just': 'recursos en',
	'one site': 'un solo sitio',
	'Your All-in-One':
		'Tu puerta de entrada todo en uno para explorar el conocimiento',
	'Access dictionaries, articles':
		'Accede a diccionarios, artículos, patentes, recursos de Gale, Empleos y más, todo en un solo lugar. Explora el conocimiento con Aquino, nuestra inteligencia artificial, y descubre recursos confiables de forma rápida e inteligente.',
	'Find hundreds of sources searching by topics':
		'Encuentra cientos de fuentes buscando por temas',
	'Access specialized resources organized':
		'Accede a recursos especializados organizados por tema y enfocados en los programas académicos de la universidad. Encuentra fácilmente la información más relevante para tu campo de estudio.',
	'Need help?': '¿Necesitas ayuda?',
	"We're here to help you every step of the way":
		'Estamos aquí para ayudarte en cada paso del camino.',
	'We understand that while browsing':
		'Entendemos que, al navegar por nuestra biblioteca o utilizar nuestros recursos, pueden surgir preguntas, inconvenientes técnicos o incluso ideas que quieras compartir. Por eso contamos con un sistema de soporte accesible y ágil, diseñado para que nunca te sientas solo en el proceso.',
	'In any library view':
		'En cualquier vista de la biblioteca encontrarás un ícono con un signo de interrogación (?) y el mensaje',
	'Do you have any questions or suggestions?':
		'¿Tienes alguna pregunta o sugerencia?',
	'This is your direct access to our support team':
		'Este es tu acceso directo a nuestro equipo de soporte. Al hacer clic, podrás crear un ticket en segundos. Solo cuéntanos brevemente lo que necesitas y nosotros nos encargaremos del resto.',
	'Submit a support request': 'Enviar una solicitud de soporte',
	'Learn about our Collection Development Policy':
		'Conoce nuestra Política de Desarrollo de Colecciones',
	'In our library, every resource counts':
		'En nuestra biblioteca, cada recurso cuenta. Por eso seguimos una Política de Desarrollo de Colecciones que garantiza la calidad, pertinencia y diversidad del contenido que ofrecemos. Este documento explica los criterios que usamos para seleccionar, evaluar y actualizar los materiales disponibles, siempre teniendo en cuenta las necesidades de nuestra comunidad educativa.',
	"If you'd like to know how we select content":
		'Si deseas conocer cómo seleccionamos el contenido, los principios que guían nuestras decisiones y cómo puedes participar con sugerencias o comentarios, te invitamos a descubrir más.',
	'Download the full policy':
		'Descarga la política completa y descubre cómo estamos construyendo juntos una biblioteca de calidad.',
	'Discover all the': 'Descubre todas las',
	'scientific news': 'noticias científicas',
	'Stay up to date with news and updates':
		'Mantente al día con noticias y actualizaciones. Explora nuestra biblioteca virtual para ampliar tu conocimiento',
	'Your question has a place, and so does our answer':
		'Tu pregunta tiene un lugar, y nuestra respuesta también',

	// NavigationBarResources
	'Main Panel': 'Panel Principal',
	'Other Sections': 'Otras secciones',
	// Footer
	'All rights reserved': 'Todos los derechos reservados',
	'Powered by': 'Desarrollado por',
	// Navbar
	'Global News': 'Noticias',
	FAQs: 'Preguntas frecuentes',
	// Generics
	new: 'nuevo',
	Consult: 'Consultar',
	NEW: 'NUEVO',
	'View more': 'Ver más',
	'show more': 'mostrar más',
	Filter: 'Filtrar',
	'In Person': 'Presencial',
	Remote: 'Remoto',
	remote: 'remoto',
	'What are you searching?': 'Qué estás buscando?',
	'Show more jobs': 'Mostrar más trabajos',
	'Please enter a search term': 'Por favor, introduzca un término de búsqueda',
	Filters: 'Filtros',
	Sources: 'Recursos',
	Year: 'Año',
	Colors: 'Colores',
	'Apply filters': 'Aplicar filtros',
	'Remove all filters': 'Remover todos los filtros',
	Back: 'Anterior',
	Published: 'Publicado',
	'Apply for this vacancy here': 'Aplica a esta vacante aquí',
	'Employment summary': 'Resumen de empleo',
	'Working time': 'Horario de trabajo',
	Job: 'Empleo',
	Workplace: 'Lugar de trabajo',
	Salary: 'Salario',
	more: 'más',
	less: 'menos',
	details: 'detalles',
	View: 'Ver',
	Next: 'Siguiente',
	Skip: 'Omitir',
	'Searched term': 'Término buscado',
	results: 'resultados',
	'Do a search': 'Hacer una búsqueda',
	Search: 'Buscar',
	'Do a job search': 'Hacer una búsqueda de empleo',
	'Search for topic': 'Búsqueda por tema',
	'Search for authors': 'Búsqueda por autor',
	English: 'Inglés',
	Spanish: 'Español',
	Simple: 'Simple',
	Advance: 'Avanzado',
	Show: 'Mostrar',
	'Show less art periods': 'Mostrar menos periodos',
	'Show all art periods': 'Mostrar todos los periodos',
	Delete: 'Eliminar',
	'Copy link': 'Copiar link',
	'Sign off': 'Cerrar sesión',
	'Sign in': 'Iniciar sesión',
	'Sign up': 'Registrarse',
	'Successfully deleted': 'Eliminado satisfactoriamente.',
	// Instructions
	'Crafting effective search queries':
		'Elaborar consultas de búsqueda efectivas es crucial para la recuperación de información. Mejora la precisión utilizando ecuaciones de búsqueda con operadores lógicos, refinando y adaptando las consultas según criterios específicos.',
	'To refine your searches you can use':
		'Para refinar tus búsquedas puedes usar',
	'to specify exact matching': 'para especificar coincidencias exactas',
	'to add logic to to your search': 'para añadir lógica a tu búsqueda',
	'to group your search terms': 'para agrupar tus términos de búsqueda',
	// EBooks
	'To view details select the job you are interested in':
		'Para ver el detalle, seleccione el trabajo que le interesa',
	'No data found': 'No se encontraron resultados',
	'Welcomem to Olib': 'Bienvenido a Aquinas Online Library!',
	'Explore our eBooks':
		'Explora nuestros libros electrónicos, ahora con títulos exclusivos de McGraw Hill. Encuentra recursos de alta calidad en gestión, economía y más para apoyar tu trayectoria académica.',
	'You now have exclusive access to select books':
		'Ahora tienes acceso exclusivo a una selección de libros de McGraw Hill. Explora títulos sobre gestión, finanzas, economía y mucho más, disponibles para nuestra comunidad.',
	'Go to EBooks': 'Ir a Libros',
	'Click Next': 'Haz clic en "Siguiente" para comenzar a explorar.',
	'Access the best academic resources':
		'Accede a los mejores recursos académicos y mejora tu aprendizaje. ¡Empieza a descubrir hoy!',
	// Help
	'Aquinas Online Library FAQ':
		'Preguntas frecuentes sobre Aquinas Online Library',
	'What is Aquinas Online Library?': '¿Qué es Aquinas Online Library?',
	'What is aquinas online library description':
		'Aquinas Online Library es una biblioteca en línea diseñada para ofrecer contenido académico en diferentes formatos.',
	'How can I get the most out of Aquinas Online Library?':
		'¿Cómo puedo sacar el mayor provecho de Aquinas Online Library?',
	'How can I get the most out of Aquinas Online Library description':
		'Entendemos que familiarizarse con una nueva plataforma puede tomar tiempo. Por eso hemos creado un video interactivo detallado para guiarte a través de todas las funcionalidades que Aquinas Online Library tiene para ofrecer.',
	'How can I find a book from the library?':
		'¿Cómo puedo encontrar un libro en la biblioteca?',
	'How can I find a book from the library description':
		'Puedes usar el catálogo en línea y solicitarlo. Si el libro se encuentra en otra biblioteca del campus, puedes traerlo a través del Préstamo Interbibliotecario a esta sección donde están el formulario y los procedimientos.',
	'How can I make a search to find information for my paper?':
		'¿Cómo puedo hacer una búsqueda para encontrar información para mi trabajo?',
	'How can I make a search to find information for my paper description':
		'Hay muchos recursos en la Biblioteca en Línea de Aquinas que puedes usar según el tema que hayas seleccionado. Si no estás familiarizado con tu tema, será útil que comiences tu búsqueda usando un diccionario. Una vez que te familiarices con los términos, será más fácil encontrar el recurso más relevante para comenzar tu búsqueda.',
	'Are there any guides for writing a paper?':
		'¿Hay guías para redactar un trabajo?',
	'You can go to': 'Puedes ir a',
	'Academic Writer': 'Academic Writer',
	'This is a tutorial that provides basic instructions':
		'. Este es un tutorial que proporciona instrucciones básicas sobre el estilo APA séptima edición. También puedes usar Purdue OwL',
	'How can I find a book?': '¿Cómo puedo encontrar un libro?',
	'How can I find a book description':
		'Puedes encontrarlo en la sección "Libros", donde puedes aplicar filtros como año de publicación, edición, autor, palabra clave e idioma (inglés y español).',
	'How can I access the e-books?':
		'¿Cómo puedo acceder a los libros electrónicos de las editoriales asociadas con la biblioteca?',
	'How can I access the e-books description':
		"En la sección de 'libros electrónicos' encontrarás una integración especializada para estas colecciones. Aquí encontrarás textos seleccionados específicamente para los programas de tu institución educativa.",
	'Can I get support for building my bibliography?':
		'¿Puedo obtener apoyo para construir mi bibliografía si estoy trabajando en un trabajo o investigación?',
	'Can I get support for building my bibliography description':
		'¡Por supuesto! Nuestro bibliotecario tiene acceso a bases de datos y recursos para apoyarte. Debes contactarlo por correo electrónico a librarian@aquinasnetwork.com o crear un ticket de ayuda usando el botón de ayuda. Solo recuerda registrar el tema en el que estás trabajando y el alcance de tu investigación. Te contactarán si tienen preguntas y compartirán una serie de artículos que podrían ayudarte.',
	'What should I do?':
		'¿Qué debo hacer si no puedo encontrar una referencia específica en la biblioteca?',
	'What should I do description':
		'Puedes enviar un correo electrónico a nuestro bibliotecario a librarian@aquinasnetwork.com o crear un ticket de ayuda usando el botón de ayuda. Ellos te ayudarán a encontrarla o te sugerirán otras que coincidan con tus criterios de búsqueda.',
	'How can I get a citation tool?':
		'¿Cómo puedo obtener una herramienta para generar citas?',
	// Chat
	'Do you have any question or suggestions?':
		'¿Tienes alguna pregunta o sugerencia?',
	'Thank you! Your ticket has been successfully created':
		'¡Gracias! Tu ticket ha sido creado con éxito.',
	'ticket successfully created description':
		'Estamos trabajando en tu solicitud y será atendida en las próximas horas. Nos pondremos en contacto contigo lo antes posible.',
	'Oops! A problem has occurred': '¡Vaya! Ha ocurrido un problema',
	'A problem has occurred description':
		'Por favor, intenta enviar tu solicitud nuevamente.',
	"Need a librarian's advice or is something not working?":
		'¿Necesitas el consejo de un bibliotecario o algo no está funcionando?',
	"We're here to help!": '¡Estamos aquí para ayudarte!',
	Type: 'Tipo',
	Technician: 'Técnico',
	Librarian: 'Bibliotecario',
	Urgency: 'Urgencia',
	High: 'Alta',
	Medium: 'Media',
	Low: 'Baja',
	'Institution name': 'Nombre de la institución',
	'Contact information': 'Información de contacto',
	Phone: 'Teléfono',
	'Full name': 'Nombre completo',
	Email: 'Correo electrónico',
	Subject: 'Asunto',
	Description: 'Descripción',
	'Create a ticket': 'Crear un ticket',
	// Dictionary
	'Content in this word': 'Contenido en esta palabra',
	Definition: 'Definición',
	History: 'Historia',
	Stem: 'Raíz',
	'Entries near': 'Resultados similares',
	Synonyms: 'Sinónimos',
	'Related terms': 'Términos relacionados',
	Copy: 'Copiar',
	'Generate another response': 'Generar otra respuesta',
	// GALE
	'Go to': 'Ir a',
	'Medical description':
		'Accede a información actualizada y confiable sobre enfermería, medicina y ciencias de la salud. Ideal para estudiantes, investigadores y profesionales del área.',
	'Science description':
		'Accede a artículos revisados por pares y publicaciones científicas de diversas disciplinas. Un recurso esencial para el trabajo académico y la exploración científica.',
	'Human description': 'Explora el cuerpo humano con recursos interactivos y visuales detallados. Ideal para estudiantes y profesionales de ciencias de la salud.',
	'Gale has joined our collection': 'Gale se ha unido a nuestra colección',
	'with new and valuable resources': 'con recursos nuevos y valiosos.',
	'We are excited to introduce':
		'Estamos emocionados de presentar esta incorporación que ampliará tus oportunidades de aprendizaje y',
	'research opportunities': 'de investigación',
	'Back to Home': 'Volver al inicio',
	'Delete all': 'Borrar todo',
	// AI
	'Go back': 'Volver',
	"Hello! I'm Aquino, your new virtual study partner":
		'¡Hola! Soy Aquino, tu nuevo compañero virtual de estudio.',
	'Do you have any questions about a particular topic?':
		'¿Tienes alguna pregunta sobre un tema en particular? ¡No dudes en preguntar! Para brindarte la mejor información, puedo ayudarte a encontrar los artículos más relevantes en nuestra biblioteca virtual.',
	'Please let me know when you would like to switch topics so I can offer you more accurate results':
		'Por favor, avísame cuando quieras cambiar de tema para poder ofrecerte resultados más precisos.',
	'Remember, while I am a powerful tool':
		'Recuerda que, aunque soy una herramienta poderosa, siempre es buena idea verificar mis respuestas con otras fuentes para asegurarte de tener la información más completa. ¡Empecemos a explorar juntos!',
	'Make searches in libraries from different sources and topics in  seconds':
		'Realiza búsquedas en bibliotecas de diferentes fuentes y temas en segundos.',
	'Make quick searches in a variety of specialized articles':
		'Haz búsquedas rápidas en una variedad de artículos especializados.',
	'This assistant can provide automated responses. Always verify key information before making decisions':
		'Este asistente puede proporcionar respuestas automatizadas. Verifica siempre la información clave antes de tomar decisiones.',
	'Make searches in libraries from different sources and topics in seconds':
		'Haz búsquedas en librerías de diferentes temas y recursos en segundos.',
	'Aquino is your artificial intelligence assistant':
		'Aquino es tu asistente de inteligencia artificial diseñado para realizar búsquedas rápidas y eficientes en una amplia variedad de fuentes y artículos especializados.',
	'Type your search term here': 'Escribe tu pregunta aquí',
	'Here is your answer about': 'Aquí está tu respuesta acerca de',
	'These are some questions related to this session':
		'Estas son preguntas relacionadas',
	'I hope the information has been helpful in your search':
		'Espero que la información haya sido útil en tu búsqueda!',
	'This assistant can provide automated responses':
		'Este asistente puede proporcionar respuestas automatizadas. Verifica siempre la información clave antes de tomar decisiones.',
	'Access hundreds of Academic Documents':
		'Accede a cientos de documentos académicos',
	'Our platform puts a world of knowledge at your fingertips':
		'Nuestra plataforma pone un mundo de conocimiento al alcance de tu mano, proporcionándote las herramientas y recursos que necesitas para tener éxito en tus estudios.',
	// Favorite
	'Successfully saved': 'Guardado con éxito',
	'Find it in your favorites folder': 'Encuéntralo en tu carpeta de favoritos',
	Collections: 'Colecciones',
	'No favorites yet. Start adding your top picks':
		'Aún no tienes favoritos. ¡Empieza a agregar tus selecciones favoritas!',
	'Yes, delete': 'Sí, eliminar',
	'No, cancel': 'No, cancelar',
	'Are you sure you want to delete this item?':
		'¿Estás seguro de que deseas eliminar este elemento?',
	Favorite: 'Favorito',
	Favorites: 'Favoritos',
	// Login
	Return: 'Regresar',
	'Welcome to': 'Bienvenido a',
	'Log in': 'Ingresa',
	Login: 'Ingresar',
	'to your account and': 'a tu cuenta y',
	'explore our resources': 'explora nuestros recursos',
	User: 'Usuario',
	'Email or username': 'Correo o nombre de usuario',
	Password: 'Contraseña',
	'Email or username are incorrect':
		'El correo electrónico o el nombre de usuario son incorrectos.',
	'Need to create an account?': '¿Necesitas crear una cuenta?',
	'Forgot your password?': '¿Olvidaste tu contraseña?',
	'Happy reading! Welcome to your personalized Virtual Library':
		'¡Feliz lectura! Bienvenido a tu Biblioteca Virtual personalizada. ¿Necesitas ayuda para iniciar sesión? Tu bibliotecario está a solo un correo de distancia en',
	'Check Moodle for the latest updates':
		'Consulta Moodle para ver las últimas actualizaciones.',
	// Sign up
	'Already have a user account?': '¿Ya tienes una cuenta de usuario?',
	'Create your account': 'Crea tu cuenta',
	'and access our': 'y accede a nuestros',
	'exclusive resources': 'recursos exclusivos.',
	'Error on request. Please try again.':
		'Error en la solicitud. Por favor, inténtalo de nuevo.',
	'Your request was successfully processed. Your user credentials will be sent to your email.':
		'Tu solicitud se procesó correctamente. Tus credenciales de usuario serán enviadas a tu correo electrónico.',
	'User already exists': 'El usuario ya existe',
	// Recover
	'Verify your identity: enter your email to receive your code':
		'Verifica tu identidad: ingresa tu correo electrónico para recibir tu código.',
	'Enter the verification code sent to your email':
		'Ingresa el código de verificación enviado a tu correo electrónico',
	Validate: 'Validar',
	'Receive Code': 'Recibir código',
	'Enter the new password for your account':
		'Ingresa la nueva contraseña para tu cuenta',
	'Change password': 'Cambiar contraseña',
	'Your new password has been successfully changed. Your new user credentials will be sent to your email':
		'Tu nueva contraseña ha sido cambiada exitosamente. Tus nuevas credenciales de usuario serán enviadas a tu correo electrónico.',
	'An error occurred during the process. Please try again':
		'Ocurrió un error durante el proceso. Por favor, inténtalo de nuevo.',
	'Already have an account?': '¿Ya tienes una cuenta?',
	'New password': 'Nueva contraseña',
	Code: 'Código',
	'Authorization code': 'Código de autorización',
	'Welcome, select the mode you want to use to login.':
		'Bienvenido, seleccione el modo que desea utilizar para iniciar sesión.',
	'Full-time': 'Tiempo completo',
	'Part-time and Full-time': 'Tiempo parcial y completo',
	'Full-time and Part-time': 'Tiempo completo y parcial',
	'Part-time': 'Tiempo parcial',
	Internship: 'Práctica',
	Anywhere: 'Remoto',
	'Pediatric phlebotomy': 'Flebotomía pediátrica',
	'Climate change AND renewable energy':
		'Cambio climático AND energías renovables',
	'Artificial intelligence OR machine learning':
		'Inteligencia artificial OR aprendizaje automático',
	'Smartphones NOT Apple': 'Smartphones NOT Apple',
	'(climate change AND renewable energy) OR (global warming AND sustainable energy)':
		'(Cambio climático AND energías renovable) OR (calentamiento global AND energías sostenibles)',
	'Peer reviewed': 'Revisión por pares',
	Keywords: 'Palabras clave',
	'URL detail': 'Enlace de detalle',
	Location: 'Ubicación',
	'Year of work': 'Año de la obra',
	Link: 'Enlace',
	Dimensions: 'Dimensiones',
	Materials: 'Materiales',
	'See more': 'Ver más',
	Artist: 'Artista',

	'Health Sciences': 'Ciencias de la salud',
	Multidisciplinary: 'Multidisciplinario',
	Education: 'Educación',
	'Business Administration': 'Administración de empresas',
	'Humanities and Social Sciences': 'Humanidades y ciencias sociales',
	'Technology - Engineering': 'Tecnología - Ingeniería',
	'Beauty and wellness': 'Belleza y bienestar',
	'Biology, Earth Sciences': 'Biología, ciencias de la tierra',
	'Do a art search': 'Hacer una búsqueda de arte',
	'My favorites': 'Mis favoritos',
	'Getting Started': 'Comenzando',
	'with Aquinas Online Library': 'con Aquinas Online Library',
	'Learn to use OLIB with these two interactive videos':
		'Aprenda a utilizar OLIB con estos dos vídeos interactivos, disponibles en inglés y español. Son los únicos tutoriales que necesita para navegar por la plataforma, buscar recursos y personalizar su experiencia de manera eficiente.',
	'Make the most of OLIB and enhance your learning experience':
		'Aprovecha al máximo OLIB y mejora tu experiencia de aprendizaje.',
	'New Resources': 'Nuevos recursos',
	Close: 'Cerrar',
	Topic: 'Tema',
	Language: 'Idioma',
	Welcome: '¡Bienvenido!',
	'Use your': 'Usa tu',
	Wordpress: 'Wordpress',
	'username and password to': 'nombre de usuario y contraseña para',
	'continue on': 'continuar en',
	Olib: 'Aquinas Online Library',
	'Username or Email Address': 'Nombre de usuario o Email',
	'Login with Wordpress': 'Iniciar sesión con Wordpress',
	'Enter your': 'Ingresa tu',
	'username and password in the fields to log in and access all features':
		'nombre de usuario/email y contraseña en los campos para iniciar sesión y acceder a todas las funciones',
	'Connection failed, try again later.':
		'La conexión falló, inténtalo de nuevo más tarde.',
	'Invalid credentials': 'Credenciales inválidas',
	'Username or Email Address is required':
		'El nombre de usuario o la dirección de correo electrónico son obligatorios',
	'Password is required': 'La contraseña es obligatoria',
};
